import { createApiCall } from 'lib/base';

const DELETE_SUBSCRIPTION = 'DELETE_SUBSCRIPTION';

const deleteSubscriptionApi = createApiCall<{ id: string }>(
  DELETE_SUBSCRIPTION,
  ({ id }) => ({
    endpoint: `api/admin/subscriptions/${id}`,
    method: 'DELETE',
  })
);

export default deleteSubscriptionApi;
